
function Subject(calculator)
{
  this.calculator = calculator;
  this.position = calculator.create();
  this.direction = calculator.create();
  this.velocity = calculator.create();
  this.maxVelocity = Number.POSITIVE_INFINITY;
}

Subject.prototype = 
{
  update: function(force, dt)
  {
    var calc = this.calculator;

    if ( calc.isNaN( force ) )
    {
      return;
    }
    
    this.velocity = calc.adds( this.velocity, force, dt );

    if ( this.maxVelocity !== Number.POSITIVE_INFINITY )
    {
      this.velocity = calc.clamp( this.velocity, 0, this.maxVelocity );
    }

    this.position = calc.adds( this.position, this.velocity, dt );

    this.direction = calc.copy( this.direction, this.velocity );

    var length = calc.length( this.direction );

    if ( length !== 0.0 )
    {
      this.direction = calc.scale( this.direction, 1.0 / length );
    }
  }
};